import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// withCredentials sends the httpOnly access_token cookie automatically.
// We do NOT read or write any token from localStorage — that's an XSS risk.
export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && e.msg) || JSON.stringify(e)).join("; ");
  if (detail && detail.msg) return detail.msg;
  return String(detail);
}

export const fmtMoney = (n) =>
  (n == null ? 0 : Number(n)).toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 0,
    maximumFractionDigits: 1,
  });

export const fmtNum = (n) =>
  (n == null ? 0 : Number(n)).toLocaleString("en-US", { maximumFractionDigits: 1 });
